module.exports = __webpack_public_path__ + "fonts/mc.64e9d53.woff";